import React from 'react'

class SingleRate extends React.Component {
  render() {
    const {
      repaymentWithFrequency,
      interestType,
      rateLabel,
    } = this.props;

    return(
      <div>
        You will repay <strong>{ repaymentWithFrequency }</strong> at a { interestType } rate of <strong>{ rateLabel }</strong> p.a.
        <br />
        <br />
      </div>
    )
  }
}

export default SingleRate;

